import React from "react";

import { useTranslation } from "react-i18next";

import {
  Container,
  ContainerTextCenter,
  Icon,
  IconsContainer,
  TopBar,
} from "./styles";
import microIcon from "../../../assets/svg/micro.svg";
import videoIcon from "../../../assets/svg/video.svg";
import { IAuthLeftTemplate } from "../interface";
import { getBackgroundImage } from "../utils";

export const LeftTemplate: React.FC<IAuthLeftTemplate> = ({
  backgroundImage,
}) => {
  const { t } = useTranslation();

  return (
    <Container backgroundImage={getBackgroundImage({ backgroundImage })}>
      <ContainerTextCenter>
        <TopBar />
        <strong>{t("landing.tagline")}</strong>
        <span>{t("landing.taglineDescription")}</span>
        <IconsContainer>
          <Icon>
            <img src={microIcon} alt="microIcon" />
          </Icon>
          <Icon>
            <img src={videoIcon} alt="videoIcon" />
          </Icon>
        </IconsContainer>
      </ContainerTextCenter>
    </Container>
  );
};
